import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { createPartnerContactPersonAsync, updatePartnerContactPersonAsync, deletePartnerContactPersonAsync } from './partnerContactPersonThunk';
const initialState = {
    status: APIStatus.IDLE
};
export const partnerContactPersonSlice = createSlice({
    name: 'partnerContactPerson',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createPartnerContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createPartnerContactPersonAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(createPartnerContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updatePartnerContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updatePartnerContactPersonAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(updatePartnerContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deletePartnerContactPersonAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deletePartnerContactPersonAsync.fulfilled, (state) => {
            state.status = APIStatus.SUCCESS;
        })
            .addCase(deletePartnerContactPersonAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export default partnerContactPersonSlice.reducer;
